export const LANGUAGES = {
  en: "en",
}

export const DEFAULT_APP_LANGUAGE = LANGUAGES.en
